import type { MenuConfig } from '~typings/menu'

export default [] as MenuConfig[]
